<div class="uw-dialog-header">
  <h1 class="uw-dialog-heading">{{ "campaign.campaign_email_preview" | translate }}</h1>

  <button [attr.aria-label]="'aria.close' | translate" cdkFocusInitial mat-icon-button mat-dialog-close>
    <mat-icon>
      close
    </mat-icon>
  </button>
</div>

<div class="uw-dialog-content">
  <div [innerHTML]="body | safeHtml"></div>
</div>

<div class="uw-dialog-footer" >
  <div class="uw-actions">      
    <button class="uw-stroked-button" mat-dialog-close>
      {{ "common.close" | translate }}
    </button>

  </div>
</div>

